const hashCode = (str) => {
  let h = 0;
  // eslint-disable-next-line no-plusplus, no-bitwise
  for (let i = 0; i < str.length; i++) h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
  return h;
};
export default hashCode;
